module.exports = __webpack_public_path__ + "static/media/portfolio1.2aec16a8.svg";